import { injectable } from '@servicetitan/react-ioc';
import { action, computed, makeObservable, observable } from 'mobx';
import { JobListItemWeb } from '../../../../../api/portal-dashboard.api';

@injectable()
export class AppointmentDrawerStore {
    @observable job?: JobListItemWeb;

    @computed get isOpen() {
        return !!this.job;
    }

    constructor() {
        makeObservable(this);
    }

    @action
    open = (job: JobListItemWeb) => {
        this.job = job;
    };

    @action
    close = () => {
        this.job = undefined;
    };
}
